import { TokenHelper } from "./TokenHelper";

export class AnchorHelper {
    private static _instance: AnchorHelper;

    public static get Instance(): AnchorHelper {
        if (AnchorHelper._instance == null) {
            AnchorHelper._instance = new AnchorHelper();
        }
        return AnchorHelper._instance;
    }

    constructor() {


    }

    public Init = async () => {
        await this.initInterceptor();
    }

    private initInterceptor = async () => {
        document.addEventListener("click", (e) => {
            if (this.filterAnchor(e))
                return;

        })

        document.addEventListener("submit", (e) => {
            this.filterForm(e);
        })
    }


    private filterAnchor = (e: MouseEvent) => {
        let target = e.target as HTMLElement;
        if (target.tagName != "A")
            target = target.closest("a");

        if (target == null) {
            return false;
        }

        e.preventDefault();
        this.interceptAnchor(target as HTMLAnchorElement);
        return true;
    }

    private filterForm = (e: SubmitEvent) => {
        let target = e.target as HTMLFormElement;
        const attr = target.getAttribute("circ-token");

        if (attr == null) {
            return false;
        }

        if (!TokenHelper.Instance.TokenExists)
            return false;

        e.preventDefault();

        const url = new URL(target.action);
        url.searchParams.set("token", TokenHelper.Instance.Token);

        target.action = url.href;
        target.submit();

        return true;

    }

    private interceptAnchor = (a: HTMLAnchorElement) => {
        const attr = a.getAttribute("circ-token");

        if (attr == null) {
            location.href = a["href"];
            return;
        }

        if (!TokenHelper.Instance.TokenExists)
            return;

        location.href = a["href"] + "?token=" + TokenHelper.Instance.Token;
    }
}
